module.exports = "../dist/img/white-27.0b06.jpg";